import { createEvent, restore } from 'effector'

import type { GameClient } from './types'

export const gameClientReady = createEvent<GameClient>()
export const preloaderReady = createEvent()

export const $gameClient = restore(gameClientReady, null)
